// extracted by mini-css-extract-plugin
export default {"Loader":"loader_Loader__h+PeO"};